// The one validator for Supabase Storage object keys, shared by the SPA (signed URLs, through
// src/components/gavion/domain/privacy.ts) and the edge functions (export). Strictest rule set: 1–512
// characters of [A-Za-z0-9._-/] (so no `%`, `?`, `#`, `\`, spaces, Unicode or control characters), no
// leading `/`, and no empty, `.` or `..` segment. Nothing that could leave the bucket once a storage
// client concatenates the key into a URL passes.
const OBJECT_KEY = /^[A-Za-z0-9._\-/]{1,512}$/;

export function isSafeObjectPath(path: string): boolean {
  return (
    OBJECT_KEY.test(path) &&
    !path.startsWith("/") &&
    path.split("/").every((s) => s !== "" && s !== "." && s !== "..")
  );
}
